import axiosInstance from "config/AxiosConfig";
import { NexusDistributorCreateReq } from "domain/payload/request/nexusDistributor/NexusDistributorCreateReq";
import { NexusDistributorUpdateReq } from "domain/payload/request/nexusDistributor/NexusDistributorUpdateReq";
import { BaseResponse } from "domain/payload/response/BaseResponseDto";
import { NexusDistributorDetailResp } from "domain/payload/response/nexusDistributor/NexusDistributorDetailResp";
import { NexusDistributorListResp } from "domain/payload/response/nexusDistributor/NexusDistributorListResp";
import { NexusDistributorWithdrawalChannelConfigResp } from "domain/payload/response/nexusDistributor/NexusDistributorWithdrawalChannelConfigResp";

const NexusDistributorService = () => {
    const nexusDistributorList = async (
        token: string,
        search: string | null,
        page: number | null,
        size: number | null
    ): Promise<BaseResponse<NexusDistributorListResp[]>> => {
        try {
            const response = await axiosInstance.get(`/v1/legacy/cms/nexus-distributor/list`, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                params: {
                    search: search,
                    page: page,
                    size: size
                }
            });

            return response.data;

        } catch (error: any) {
            throw error.response.data.message;
        }
    };

    const nexusDistributorDetail = async (
        token: string,
        id: string
    ): Promise<BaseResponse<NexusDistributorDetailResp>> => {
        try {
            const response = await axiosInstance.get(`/v1/legacy/cms/nexus-distributor/detail`, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                params: {
                    id
                }
            });

            return response.data;
        } catch (error: any) {
            throw error.response.data.message;
        }
    };

    const nexusDistributorWithdrawalChannelConfig = async (
        token: string,
        search?: string
    ): Promise<BaseResponse<NexusDistributorWithdrawalChannelConfigResp[]>> => {
        try {
            const response = await axiosInstance.get(`/v1/legacy/cms/nexus-distributor/channel-config`, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                params: search ? { search } : undefined
            });

            return response.data;
        } catch (error: any) {
            throw error.response.data.message;
        }
    };

    const nexusDistributorCreate = async (
        token: string,
        request: NexusDistributorCreateReq
    ): Promise<BaseResponse<NexusDistributorDetailResp>> => {
        try {
            const response = await axiosInstance.post(`/v1/legacy/cms/nexus-distributor/create`, request, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            return response.data;
        } catch (error: any) {
            throw error.response.data.message;
        }
    };

    const nexusDistributorUpdate = async (
        token: string,
        request: NexusDistributorUpdateReq
    ): Promise<BaseResponse<NexusDistributorDetailResp>> => {
        try {
            const response = await axiosInstance.put(`/v1/legacy/cms/nexus-distributor/update`, request, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            return response.data;
        } catch (error: any) {
            throw error.response.data.message;
        }
    };

    const nexusDistributorDelete = async (
        token: string,
        id: string
    ): Promise<BaseResponse<any>> => {
        try {
            const response = await axiosInstance.delete(`/v1/legacy/cms/nexus-distributor/delete?id=${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            return response.data;
        } catch (error: any) {
            throw error.response.data.message;
        }
    };

    return { nexusDistributorList, nexusDistributorDetail, nexusDistributorCreate, nexusDistributorUpdate, nexusDistributorDelete, nexusDistributorWithdrawalChannelConfig };
};

export default NexusDistributorService;